import { render, staticRenderFns } from "./HeroSupplier.vue?vue&type=template&id=4b9793c0&scoped=true"
import script from "./HeroSupplier.vue?vue&type=script&lang=js"
export * from "./HeroSupplier.vue?vue&type=script&lang=js"
import style0 from "./HeroSupplier.vue?vue&type=style&index=0&id=4b9793c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9793c0",
  null
  
)

export default component.exports